// GAVION call-brief-pipeline: le brief avant l'appel (spéc. 2026-10-22-call-brief-pipeline-design).
export const callBriefFr = {
  card: {
    title: "Avant l'appel",
    what_they_do: "Ce qu'ils font",
    hook: "Accroche",
    history: "Historique",
    preparing: "Préparation…",
    unavailable: "Brief indisponible",
    // GAVION ops-lookup
    ops_contact: "Responsable des opérations",
    ops_searching: "Recherche en cours…",
    ops_not_found:
      "Non trouvé — demander à la réception qui s'occupe des opérations",
    ops_unknown:
      "Pas encore cherché — demander à la réception qui s'occupe des opérations",
    ops_not_searched:
      "Pas de recherche automatique pour cette compagnie — demander à la réception qui s'occupe des opérations",
    ops_source: "source",
    ops_manual: "saisi à la main",
    ops_add_contact: "Ajouter comme contact",
    ops_contact_exists: "Déjà dans les contacts",
    ops_contact_added: "Contact ajouté",
    ops_contact_failed: "Le contact n'a pas pu être ajouté. Réessayez.",
    ops_contact_note: "Trouvé par l'IA — source %{url}",
  },
  timeline: { title: "Brief" },
  settings: {
    title: "Brief avant l'appel",
    hint: "Trois lignes en haut de la fiche de la compagnie (« Ce qu'ils font », « Accroche », « Historique »), préparées à l'avance pour la compagnie affichée et les 3 suivantes de la liste. Les deux premières sont écrites par l'IA (Claude Haiku 5.5, environ 0,03 ¢ par brief, gardé 30 jours).",
    enabled: "Brief avant l'appel",
    cap: "Limite quotidienne de briefs",
    cap_hint:
      "Nombre maximal de briefs écrits par l'IA par jour, pour toute l'équipe (0 à 5000). « Historique » reste affiché.",
    cap_invalid: "Entrez un nombre entier de 0 à 5000.",
    // GAVION ops-lookup
    ops_cap: "Limite quotidienne de recherches « Responsable des opérations »",
    ops_cap_hint:
      "Compagnies recherchées par jour pour toute l'équipe (jusqu'à 3 recherches web chacune ; 0 à 5000, 0 = désactivé) : une fois par compagnie, environ 3 ¢ chacune (Claude Haiku 5.5). Le nom n'est gardé que si une source publique le dit.",
    save: "Enregistrer",
    saved: "Réglages du brief enregistrés.",
    save_failed:
      "Les réglages du brief n'ont pas pu être enregistrés. Réessayez.",
  },
  history: {
    first_call: "Premier appel",
    attempt: "Appel n° %{n}",
    last: "%{outcome}, %{date}",
    note: "Note : « %{text} »",
    callback: "Rappel demandé : %{date}",
  },
};
